import React, { forwardRef, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { uniqBy } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';

const PrivadoMappingForm = forwardRef(function PrivadoMappingForm({ disableProjectFields = false, ...props }, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { repositoryId, repositoryName } = props.record;

      const repositoryIdArray = repositoryId.split(",");
      const repositoryNameArray = repositoryName.split(",");

      return repositoryIdArray.map((id, index) => ({ id, name: repositoryNameArray[index]}));
    }
    return [];
  });
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });

  const fetchProjectOptions = useCallback((params) => {
    const setOptionsFromPagination = (option) => {
      setProjects(prev => uniqBy([...prev,...option], 'id'));
    };
    const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {...params, login_id: props.loginConfigId});
    promise.then((data) => setOptionsFromPagination(data.projects))
    return { promise,cancel}
}, [props.toolName, props.loginConfigId]);

  const getExtraFieldsData = useCallback((config) => {
    const { repositoryId } = config;
    const data = projects.reduce((acc,cv) =>{
      const { id, name } = cv;
      if(repositoryId.includes(id)){
        acc.id.push(id);
        acc.name.push(name);
      }
      return acc;
    },{id:[],name:[]})
    return ({
      repositoryId: data.id.join(),
      repositoryName: data.name.join()
    });
  },[projects]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { repositoryId } = config;
    return { repositoryId: repositoryId.split(",") };
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'repositoryId',
      colSpan: '12',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Repository Name',
      required:true,
      disabled: disableProjectFields,
      props: {
        mode: "multiple",
        autoFocus: !disableProjectFields,
        api: fetchProjectOptions,
      }
    }
  ]), [ disableProjectFields, fetchProjectOptions]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default PrivadoMappingForm;